const state = () => ({
  requestStatus: 'unknown',
  loaded: false,
  stats: {},
  quotas: {},
  clusterStatPending: false,
  computeClusterDetails: {}
});

export default state;
